import { bundledDuaDescriptors } from './dua-metadata'

/** Describes bundled dua readers for native content resolution and validation. */
export type BundledDuaRouteDescriptor = {
  slug: string
  pageCount: number
  view: 'sections' | 'grouped'
}

/**
 * Keeps the offline route list lightweight without importing the bundled text
 * datasets into the browser's global application chunk.
 */
export const bundledDuaRouteDescriptors: readonly BundledDuaRouteDescriptor[] =
  bundledDuaDescriptors.map(({ slug, pageCount, view }) => ({ slug, pageCount, view }))
